(function () {
  function initGallery(root) {
    var main = root.querySelector('[data-siokiuu-ic3600-main-image]');
    var media = root.querySelector('[data-siokiuu-ic3600-media]');
    var track = root.querySelector('[data-siokiuu-ic3600-thumbs-track]');
    var prev = root.querySelector('[data-siokiuu-ic3600-thumb-prev]');
    var next = root.querySelector('[data-siokiuu-ic3600-thumb-next]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-siokiuu-ic3600-thumb]'));
    var zoomButton = root.querySelector('[data-siokiuu-ic3600-zoom-button]');
    var zoomModal = root.querySelector('[data-siokiuu-ic3600-zoom-modal]');
    var zoomImage = root.querySelector('[data-siokiuu-ic3600-zoom-modal-image]');
    var zoomClose = root.querySelector('[data-siokiuu-ic3600-zoom-close]');
    var zoomFrame = root.querySelector('[data-siokiuu-ic3600-zoom-frame]');
    var certificationBadges = media ? media.querySelector('.siokiuu-cert-badges') : null;
    var lastFocusedElement = null;

    if (!main || !media || !thumbs.length) {
      return;
    }

    function getCurrentImageSrc() {
      return main.currentSrc || main.getAttribute('src') || '';
    }

    function setZoomImage(src) {
      if (!zoomImage || !src) {
        return;
      }

      zoomImage.setAttribute('src', src);
      zoomImage.setAttribute('alt', main.getAttribute('alt') || '');
    }

    function closeZoom() {
      if (!zoomModal || zoomModal.hidden) {
        return;
      }

      zoomModal.hidden = true;
      zoomModal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('siokiuu-ic3600-zoom-open');

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus({ preventScroll: true });
      }
    }

    function openZoom() {
      if (!zoomButton || !zoomModal || !zoomImage) {
        return;
      }

      var imageSrc = getCurrentImageSrc();
      if (!imageSrc) {
        return;
      }

      lastFocusedElement = document.activeElement;
      setZoomImage(imageSrc);
      zoomModal.hidden = false;
      zoomModal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('siokiuu-ic3600-zoom-open');

      window.requestAnimationFrame(function () {
        (zoomClose || zoomModal).focus({ preventScroll: true });
      });
    }

    function initZoom() {
      if (!zoomButton || !zoomModal || !zoomImage) {
        return;
      }

      zoomButton.addEventListener('click', function () {
        openZoom();
      });

      if (zoomClose) {
        zoomClose.addEventListener('click', closeZoom);
      }

      if (zoomFrame) {
        zoomFrame.addEventListener('click', function (event) {
          if (event.target === zoomFrame) {
            closeZoom();
          }
        });
      }

      zoomModal.addEventListener('click', function (event) {
        if (event.target === zoomModal) {
          closeZoom();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeZoom();
        }
      });
    }

    function getActiveIndex() {
      var active = root.querySelector('[data-siokiuu-ic3600-thumb].is-active');
      var index = thumbs.indexOf(active);
      return index >= 0 ? index : 0;
    }

    function updateNav() {
      var index = getActiveIndex();
      var hasMultiple = thumbs.length > 1;

      if (certificationBadges) {
        certificationBadges.classList.toggle('is-gallery-hidden', index !== 0);
        certificationBadges.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
      }

      if (prev) {
        prev.disabled = !hasMultiple || index <= 0;
      }

      if (next) {
        next.disabled = !hasMultiple || index >= thumbs.length - 1;
      }
    }

    function activateThumb(thumb) {
      var nextImage = thumb.getAttribute('data-image');

      if (nextImage) {
        main.setAttribute('src', nextImage);
        if (zoomModal && !zoomModal.hidden) {
          setZoomImage(nextImage);
        }
      }
      media.style.removeProperty('--ic3600-media-bg');

      thumbs.forEach(function (button) {
        button.classList.remove('is-active');
      });
      thumb.classList.add('is-active');

      if (track && typeof thumb.scrollIntoView === 'function') {
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }

      updateNav();
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activateThumb(thumb);
      });
    });

    if (prev) {
      prev.addEventListener('click', function () {
        var index = getActiveIndex();
        if (index > 0) {
          activateThumb(thumbs[index - 1]);
        }
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        var index = getActiveIndex();
        if (index < thumbs.length - 1) {
          activateThumb(thumbs[index + 1]);
        }
      });
    }

    initZoom();
    updateNav();
  }
  function initQuantity(root) {
    root.querySelectorAll('[data-siokiuu-ic3600-product-form]').forEach(function (form) {
      if (form.dataset.siokiuuIc3600QuantityReady === 'true') {
        return;
      }
      form.dataset.siokiuuIc3600QuantityReady = 'true';
      var input = form.querySelector('[data-siokiuu-ic3600-qty-input]');
      var minus = form.querySelector('[data-siokiuu-ic3600-qty-minus]');
      var plus = form.querySelector('[data-siokiuu-ic3600-qty-plus]');

      if (!input || !minus || !plus) {
        return;
      }

      function normalize() {
        var value = parseInt(input.value, 10);
        if (Number.isNaN(value) || value < 1) {
          value = 1;
        }
        input.value = value;
      }

      minus.addEventListener('click', function () {
        input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
      });

      plus.addEventListener('click', function () {
        input.value = Math.max(1, parseInt(input.value || '1', 10) + 1);
      });

      input.addEventListener('change', normalize);
    });
  }

  function initTabs(root) {
    root.querySelectorAll('[data-siokiuu-ic3600-tabs]').forEach(function (tabs) {
      var buttons = tabs.querySelectorAll('[data-siokiuu-ic3600-tab-button]');
      var panels = tabs.querySelectorAll('[data-siokiuu-ic3600-tab-panel]');

      if (!buttons.length || !panels.length) {
        return;
      }

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var targetId = button.getAttribute('aria-controls');

          buttons.forEach(function (item) {
            item.classList.remove('is-active');
            item.setAttribute('aria-selected', 'false');
          });

          panels.forEach(function (panel) {
            var isTarget = panel.id === targetId;
            panel.hidden = !isTarget;
            panel.classList.toggle('is-active', isTarget);
          });

          button.classList.add('is-active');
          button.setAttribute('aria-selected', 'true');
        });
      });
    });
  }

  function initRatingLink(root) {
    root.querySelectorAll('.siokiuu-ic3600-rating').forEach(function (rating) {
      if (rating.tagName.toLowerCase() === 'a' || rating.dataset.siokiuuRatingReady === 'true') {
        return;
      }

      var badge = rating.querySelector('.jdgm-prev-badge');
      if (!badge) {
        return;
      }

      var score = parseFloat(badge.getAttribute('data-average-rating') || '0');
      var count = parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10);
      if (!score || !count) {
        return;
      }

      var label = count === 1 ? 'review' : 'reviews';
      var percent = Math.max(0, Math.min(100, score * 20));
      var displayScore = score.toFixed(1);
      var link = document.createElement('a');
      var hidden = document.createElement('span');
      var stars = document.createElement('span');
      var starBase = document.createElement('span');
      var starFill = document.createElement('span');
      var reviewCount = document.createElement('span');

      link.className = 'siokiuu-ic3600-rating';
      link.href = '#siokiuu-ic3600-reviews';
      link.setAttribute('aria-label', displayScore + ' out of 5 stars based on ' + count + ' ' + label);
      link.dataset.siokiuuRatingReady = 'true';

      hidden.className = 'visually-hidden';
      hidden.textContent = displayScore + ' out of 5 stars';

      stars.className = 'siokiuu-ic3600-stars';
      stars.setAttribute('aria-hidden', 'true');
      stars.style.setProperty('--siokiuu-rating-percent', percent + '%');

      starBase.className = 'siokiuu-ic3600-stars__base';
      starBase.textContent = '★★★★★';
      starFill.className = 'siokiuu-ic3600-stars__fill';
      starFill.textContent = '★★★★★';

      reviewCount.className = 'siokiuu-ic3600-review-count';
      reviewCount.textContent = count + ' ' + label;

      stars.appendChild(starBase);
      stars.appendChild(starFill);
      link.appendChild(hidden);
      link.appendChild(stars);
      link.appendChild(reviewCount);
      rating.parentNode.replaceChild(link, rating);
    });
  }

  function initMobileStickyCart(root) {
    var sticky = root.querySelector('[data-siokiuu-mobile-sticky-atc]');
    var form = root.querySelector('[data-siokiuu-ic3600-product-form]');
    var mainAddButton = form ? form.querySelector('.siokiuu-ic3600-cart[type="submit"]') : null;
    var mainBuyButton = form ? form.querySelector('.siokiuu-ic3600-buy-now[type="submit"]') : null;
    var variantInput = form ? form.querySelector('[name="id"]') : null;
    var mainPrice = root.querySelector('.siokiuu-ic3600-price');

    if (!sticky || !form || !mainAddButton || !mainBuyButton || !variantInput) {
      return;
    }

    var addButton = sticky.querySelector('[data-siokiuu-mobile-sticky-add]');
    var buyButton = sticky.querySelector('[data-siokiuu-mobile-sticky-buy]');
    var price = sticky.querySelector('[data-siokiuu-mobile-sticky-price]');
    var comparePrice = sticky.querySelector('[data-siokiuu-mobile-sticky-compare-price]');
    var variantsNode = sticky.querySelector('[data-siokiuu-mobile-sticky-variants]');
    var moneyFormat = sticky.getAttribute('data-money-format') || '${{amount}}';
    var variants = [];
    var mediaQuery = window.matchMedia('(max-width: 749px)');
    var observer = null;
    var mainButtonIsVisible = true;
    var isCurrentVariantAvailable = !mainAddButton.disabled;

    try {
      variants = JSON.parse(variantsNode ? variantsNode.textContent : '[]');
    } catch (error) {
      variants = [];
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }

      return '$' + (Number(cents || 0) / 100).toFixed(2);
    }

    function getCurrentVariant() {
      var variantId = String(variantInput.value || '');
      return variants.find(function (variant) {
        return String(variant.id) === variantId;
      });
    }

    function syncTypography() {
      var styles = window.getComputedStyle(mainAddButton);

      [addButton, buyButton].forEach(function (button) {
        if (!button) {
          return;
        }

        button.style.fontFamily = styles.fontFamily;
        button.style.fontWeight = styles.fontWeight;
        button.style.fontStyle = styles.fontStyle;
      });
    }

    function syncDetails() {
      var variant = getCurrentVariant();
      var isAvailable = variant ? variant.available : !mainAddButton.disabled;
      isCurrentVariantAvailable = isAvailable;

      if (variant && price) {
        price.innerHTML = formatMoney(variant.price);
      } else if (mainPrice && price) {
        price.textContent = mainPrice.textContent.trim();
      }

      if (comparePrice) {
        var hasComparePrice = variant && variant.compare_at_price && variant.compare_at_price > variant.price;
        comparePrice.hidden = !hasComparePrice;
        if (hasComparePrice) {
          comparePrice.innerHTML = formatMoney(variant.compare_at_price);
        }
      }

      [addButton, buyButton].forEach(function (button) {
        if (button) {
          button.disabled = !isAvailable;
        }
      });

      setVisible(!mainButtonIsVisible);
    }

    function setVisible(visible) {
      var canShow = mediaQuery.matches && visible && isCurrentVariantAvailable;
      sticky.classList.toggle('is-visible', canShow);
      sticky.setAttribute('aria-hidden', canShow ? 'false' : 'true');
      document.body.classList.toggle('siokiuu-mobile-sticky-atc-active', canShow);

      [addButton, buyButton].forEach(function (button) {
        if (button) {
          button.tabIndex = canShow ? 0 : -1;
        }
      });
    }

    function observeMainButton() {
      if (observer) {
        observer.disconnect();
      }

      if (!mediaQuery.matches) {
        mainButtonIsVisible = true;
        setVisible(false);
        return;
      }

      observer = new IntersectionObserver(function (entries) {
        mainButtonIsVisible = entries[0].isIntersecting;
        setVisible(!mainButtonIsVisible);
      }, { threshold: 0.1 });
      observer.observe(mainAddButton);
    }

    addButton.addEventListener('click', function () {
      if (!mainAddButton.disabled) {
        mainAddButton.click();
      }
    });

    buyButton.addEventListener('click', function () {
      if (!mainBuyButton.disabled) {
        mainBuyButton.click();
      }
    });

    form.addEventListener('change', syncDetails);
    form.addEventListener('input', syncDetails);
    document.addEventListener('variant-change', syncDetails);

    new MutationObserver(syncDetails).observe(variantInput, {
      attributes: true,
      attributeFilter: ['value']
    });

    syncTypography();
    syncDetails();
    observeMainButton();

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', observeMainButton);
    } else {
      mediaQuery.addListener(observeMainButton);
    }
  }

  function init() {
    document.querySelectorAll('[data-siokiuu-ic3600]').forEach(function (root) {
      if (root.dataset.siokiuuIc3600Ready === 'true') {
        return;
      }
      root.dataset.siokiuuIc3600Ready = 'true';
      initGallery(root);
      initQuantity(root);
      initTabs(root);
      initRatingLink(root);
      initMobileStickyCart(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
